import { render, staticRenderFns } from "./TareasSidebar.vue?vue&type=template&id=225a6464&scoped=true&"
import script from "./TareasSidebar.vue?vue&type=script&lang=js&"
export * from "./TareasSidebar.vue?vue&type=script&lang=js&"
import style0 from "./TareasSidebar.vue?vue&type=style&index=0&id=225a6464&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225a6464",
  null
  
)

export default component.exports